angular.module('app.home.lazypost')

.controller('HomeLazyPostCtrl', function($location,$scope, $rootScope, $http, $filter, $state, $window, ipCookie, adminService, measureService){
    $scope.currentCategory = "latest";

    $scope.latest_list = [];
    $scope.reach_list = [];
    $scope.impact_list = [];

    $scope.latest_list_display = [];
    $scope.reach_list_display = [];
    $scope.impact_list_display = [];

    $scope.latest_list_print = [];
    $scope.reach_list_print = [];
    $scope.impact_list_print = [];


    $scope.noData = false;

    var count = 0;

    var maxItemLazyLoad = 3;
    var maxItemsPerLoad = 50;

    var offset_latest = 0;
    var offset_reach = 0;
    var offset_impact = 0;

    var linkNoImage = "/images/NoImage.png";

    var isLatestLoading = false;
    var isReachLoading = false;
    var isImpactLoading = false;
    $scope.loadBlogs = function() {

        var params = $rootScope.saveParams;
        if(params == null || (params.mention == 0 && params.blog_id == 0 && params.project_id == 0 && params.channel == 0 && params.influencerGroup == 0)) {
            return;
        } 

        isLatestLoading = $scope.currentCategory.localeCompare("latest") == 0 ? true : false;
        isReachLoading = $scope.currentCategory.localeCompare("reach") == 0 ? true : false;
        isImpactLoading = $scope.currentCategory.localeCompare("impact") == 0 ? true : false;
        params.date = $rootScope.selectedPeriod.period ? $rootScope.selectedPeriod.period.value : 7;

        if (params != undefined) {
            //params.date =  $scope.selectedDate;
            params.limit = maxItemsPerLoad;
            if ($scope.currentCategory === "latest") {
                params.offset = offset_latest;
            } else if ($scope.currentCategory === "reach") {
                params.offset = offset_reach;
            } else {
                params.offset = offset_impact;
            }

            params.category = $scope.currentCategory;

            var url1 = $rootScope.apiUrl + 'home/getHomePageBlogPosts?' + $.param(params);
            $http.get(url1, {loader: false})
                .success(function (response){
                    isLatestLoading = false;
                    isReachLoading = false;
                    isImpactLoading = false;                    

                    if (response.data != null) {
                        var count = 0;
                        angular.forEach(response.data, function (item) {
                            if(count < maxItemLazyLoad){
                                $scope[$scope.currentCategory + '_list_display'].push(
                                    {
                                        url: item.url,
                                        imageUrl: item.imageUrl == null || item.imageUrl == "" ? linkNoImage : item.imageUrl,
                                        title: item.title,
                                        influencer_id: item.blog_id,
                                        influencerName: item.influencerName,
                                        formatedDate: item.date,
                                        mentions: item.mentions,
                                        reach: item.reach,
                                        engagement: item.engagement,
                                        impact: item.impact,
                                        relativepath: item.relativepath,
                                        platform_id: item.platform
                                    }
                                );
                            } else {
                                $scope[$scope.currentCategory + '_list'].push(
                                    {
                                        url: item.url,
                                        imageUrl: item.imageUrl == null || item.imageUrl == "" ? linkNoImage : item.imageUrl,
                                        title: item.title,
                                        influencer_id: item.blog_id,
                                        influencerName: item.influencerName,
                                        formatedDate: item.date,
                                        mentions: item.mentions,
                                        reach: item.reach,
                                        engagement: item.engagement,
                                        impact: item.impact,
                                        relativepath: item.relativepath,
                                        platform_id: item.platform
                                    }
                                );
                            }

                            $scope[$scope.currentCategory + '_list_print'].push(
                                {
                                    url: item.url,
                                    imageUrl: item.imageUrl == null || item.imageUrl == "" ? linkNoImage : item.imageUrl,
                                    title: item.title,
                                    influencer_id: item.blog_id,
                                    influencerName: item.influencerName,
                                    formatedDate: item.date,
                                    mentions: item.mentions,
                                    reach: item.reach,
                                    engagement: item.engagement,
                                    impact: item.impact,
                                    relativepath: item.relativepath,
                                    platform_id: item.platform
                                }
                            );

                            count = count + 1;

                        })
                        $(".lazy-loading-" + $scope.currentCategory).hide();
                    }
                }).error(function (data) {
                    isLatestLoading = false;
                    isReachLoading = false;
                    isImpactLoading = false;  
                });

            $(".lazy-loading-" + $scope.currentCategory).show();
        }
    }

    $scope.selectTab = function(tab){
        if($state.current.url != "dashboard")
            return;
        $scope.currentCategory = tab;
        if ($scope[$scope.currentCategory + '_list_display'].length == 0) {

            if(($scope.currentCategory.localeCompare("latest") == 0 && isLatestLoading) 
                || ($scope.currentCategory.localeCompare("reach") == 0 && isReachLoading) 
                || ($scope.currentCategory.localeCompare("impact") == 0 && isImpactLoading)) {
                return;
            }

            $scope.loadBlogs();
        }
    }

    $scope.lazyLoad = function() {
        for(var i = 0 ; i < maxItemLazyLoad; i++ ){
            if($scope[$scope.currentCategory + '_list'].length > 0){
                var item =  $scope[$scope.currentCategory + '_list'][0];
                $scope[$scope.currentCategory + '_list_display'].push(item);
                $scope[$scope.currentCategory + '_list'].splice(0, 1);
            }
        }

        if ($scope[$scope.currentCategory + '_list_display'].length > 0 && $scope[$scope.currentCategory + '_list'].length == 0) {
            
            if(($scope.currentCategory.localeCompare("latest") == 0 && isLatestLoading) 
                || ($scope.currentCategory.localeCompare("reach") == 0 && isReachLoading) 
                || ($scope.currentCategory.localeCompare("impact") == 0 && isImpactLoading)) {
                return;
            }

            if ($scope.currentCategory === "latest") {
                offset_latest = offset_latest + maxItemsPerLoad;
            } else if ($scope.currentCategory === "reach") {
                offset_reach = offset_reach + maxItemsPerLoad;
            } else {
                offset_impact = offset_impact + maxItemsPerLoad;
            }
            $scope.loadBlogs();
        }   
    }

    var restartPagination = function(callback){
        $scope.latest_list = [];
        $scope.reach_list = [];
        $scope.impact_list = [];

        $scope.latest_list_display = [];
        $scope.reach_list_display = [];
        $scope.impact_list_display = [];

        $scope.latest_list_print = [];
        $scope.reach_list_print = [];
        $scope.impact_list_print = [];

        $scope.noData = false;

        offset_latest = 0;
        offset_reach = 0;
        offset_impact = 0;

        setTimeout(callback, 400);
    }

    //filter when project is clicked
    $scope.$on('refreshDashboard', function(event, args) {
        restartPagination(function(){
            $scope.loadBlogs(); 
        })
    });

    $scope.influencerOverviewPage = function(influencer_id){
        $rootScope.previousPage = $location.absUrl();
        $state.transitionTo('home.influencerOverview', {influencer_id: influencer_id}, {
            reload: false,
            inherit: true,
            notify: true
        });
    }

    $scope.postOverviewPage = function(index){
        $rootScope.previousPagePost = $location.absUrl();

        if (index.platform_id == 1) {
            $state.transitionTo('home.blogPostOverview', {url: index.url, relativepath: index.relativepath}, {
                reload: false,
                inherit: true,
                notify: true
            });
        } else if (index.platform_id == 2) {
            $state.transitionTo('home.instagramPostOverview', {url: index.url, relativepath: index.relativepath}, {
                reload: false,
                inherit: true,
                notify: true
            });
        } else if (index.platform_id == 6) {
            $state.transitionTo('home.youtubePostOverview', {url: index.url, relativepath: index.relativepath}, {
                reload: false,
                inherit: true,
                notify: true
            });
        } else if (index.platform_id == 7) {
            $state.transitionTo('home.facebookPostOverview', {url: index.url, relativepath: index.relativepath}, {
                reload: false,
                inherit: true,
                notify: true
            });
        }
    }

    $scope.PlatformIcon = function (platform_id) {
        return adminService.getPlatformIcon(platform_id);
    }

    $scope.printPdf = function() {
        $rootScope.$broadcast('printPdf');
    }

    $scope.getPageNo = function(index) {
        return Math.floor((index - 27) / 30) + 2;
    }

    $scope.isPageShown = function(index) {
        return (index - 27) % 30 == 0;
    }

    $scope.loadBlogs();
})
